export default "__VITE_ASSET__ae55KNUC__"